import { getStorageData } from 'utilities/utils';
import { registerEventProperties, trackEvent } from 'analytics/trackEvent';

/**
 * @deprecated Prefer `trackEvent` from `analytics/trackEvent` or `useTrackEvent` in components.
 */
export const sendMixpanelEvent = (eventname, properties) => {
  // TODO: __HOMEDATA-AUDIT
  const userData = getStorageData();
  const { cpa_id } = userData;
  const { cpa_user_id } = userData;
  const eventproperties = { cpa_id, cpa_user_id, ...properties };
  trackEvent(eventname, eventproperties);
};

/**
 * @deprecated Prefer `registerEventProperties` from `analytics/trackEvent`.
 */
export const registerSuperProperties = (properties) => {
  // TODO: __HOMEDATA-AUDIT
  const userData = getStorageData();
  const { cpa_id } = userData;
  const { cpa_user_id } = userData;
  // all the subsequent events get attached to this user
  const distinct_id = cpa_user_id;
  // TODO: __HOMEDATA-AUDIT
  const { user_role } = userData.userpilot_data;
  const { firm_name } = userData.userpilot_data;
  const { app_name } = userData.userpilot_data;
  const super_properties = {
    distinct_id,
    cpa_id,
    cpa_user_id,
    user_role,
    firm_name,
    app_name,
    ...properties,
  };
  registerEventProperties(super_properties);
};

// USE THIS FUNCTION DIRECTLY TO PASS ONLY THE EVENT PROPERTIES IN CASE THE ABOVE registerSuperProperties
//  IS ALREADY CALLED TO SET SUPER PROPERTIES
/**
 * @deprecated Prefer `trackEvent` from `analytics/trackEvent` or `useTrackEvent` in components.
 */
export const trackMixpanelEvent = (eventName, properties) => {
  trackEvent(eventName, properties);
};
